import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex } from 'reflexbox';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { Button, GraphQLErrorMessage, Modal, Paragraph, Popover, Spinner } from '@treams/treams-ui';

export default function EvaluationSubmissionExportModal(props: {
	submissionID: string;
	onDismiss: () => void;
}) {
	const { language } = useLocalize();
	const { t } = useTranslation();
	const [exportToPdf, { loading, error }] = graphql.useExportConversationToPdfMutation({
		variables: { conversationID: props.submissionID, locale: language.id },
	});

	const [pdfURL, setPDFURL] = useState<string | null>(null);

	useEffect(() => {
		exportToPdf().then((exportResult) => {
			const pdfURL = exportResult?.data?.exportToPDF.url;
			if (pdfURL) {
				setPDFURL(pdfURL);
			}
		});
	}, [exportToPdf]);

	return (
		<Popover center visible>
			<Modal>
				<Modal.Header
					title={t('evaluation.submission.export.modal.title')}
					onClose={props.onDismiss}
				/>
				<Modal.Contents>
					{loading && (
						<Flex py={3} alignItems={'center'} flexDirection={'column'}>
							<Paragraph mb={3}>{t('evaluation.submission.export.modal.loading')}</Paragraph>
							<Paragraph>
								<Spinner />
							</Paragraph>
						</Flex>
					)}
					{!loading && pdfURL && (
						<Flex py={3} alignItems={'center'} flexDirection={'column'}>
							<Paragraph mb={3}>{t('evaluation.submission.export.modal.downloadready')}</Paragraph>
							<Button
								type={'primary'}
								title={t('evaluation.submission.export.modal.downloadbutton')}
								onClick={() => {
									window.open(pdfURL, '_blank');
									props.onDismiss();
								}}
							/>
						</Flex>
					)}
					{error && <GraphQLErrorMessage error={error.graphQLErrors[0]} />}
				</Modal.Contents>
				<Modal.Footer>
					<Button
						type={'secondary'}
						onClick={props.onDismiss}
						title={t(loading ? 'common.cancel' : 'common.close')}
					/>
				</Modal.Footer>
			</Modal>
		</Popover>
	);
}
